module.exports = __webpack_public_path__ + "static/media/bookmark-black.66ae09a6.svg";